// @module BluePoint.ValidateRegistration.ValidateRegistration
define('BluePoint.ValidateRegistration.ValidateRegistration.View'
,	[
		'bluepoint_validateregistration_validateregistration.tpl'
	
	,	'BluePoint.ValidateRegistration.ValidateRegistration.SS2Model'
	
	,	'Backbone'
	, 	'SC.Configuration'
	, 	'jQuery'
    ]
, function (
		bluepoint_validateregistration_validateregistration_tpl
	
	,	ValidateRegistrationSS2Model
	
	,	Backbone
	,	Configuration
	,	jQuery
)
{
    'use strict';

	// @class BluePoint.ValidateRegistration.ValidateRegistration.View @extends Backbone.View
	return Backbone.View.extend({

		template: bluepoint_validateregistration_validateregistration_tpl

	,	initialize: function (options) {

			// this.model = new ValidateRegistrationModel();
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });

			var self = this;
    		this.environment = options.environment;
    		var rawList = this.environment.getConfig('validateregistration.keywordlist');

    		if (Array.isArray(rawList)) {
    		    this.keywordList = rawList.map(k => (k || '').toLowerCase().trim());
    		}
    		else if (typeof rawList === 'string') {
    		    this.keywordList = rawList.split(',').map(k => k.toLowerCase().trim());
    		}
    		else {
    		    this.keywordList = [];
    		}

    		console.log("Final keywordList:", this.keywordList);
			console.log('this.options.LoginRegisterPage', this.options.LoginRegisterPage);
			console.log('this.options.MyAccountMenu', this.options.MyAccountMenu);

			if(this.options.LoginRegisterPage) {
				this.options.LoginRegisterPage.on('afterShowContent', function () {
    				jQuery(document).on('blur', 'input[name="firstname"]', function(e){
        				self.validateFirstNameOnBlur('First name', e);
    				});
				
					jQuery(document).on('blur', 'input[name="custentity_registration_middle_initial"]', function(e){
        				self.validateFirstNameOnBlur('Middle name', e);
    				});
				
					jQuery(document).on('blur', 'input[name="lastname"]', function(e){
        				self.validateFirstNameOnBlur('Last name', e);
    				});
				
					jQuery(document).on('blur', 'input[name="company"]', function(e){
        				self.validateFirstNameOnBlur('Company', e);
    				});
				});

				this.options.LoginRegisterPage.on('beforeRegister', function (formFields) {
    		    	if (self.containsRestrictedKeyword(formFields.firstname)) {
    		    	    self.showError('First name contains a restricted keyword ' + formFields.firstname);
    		    	    return jQuery.Deferred().reject();
    		    	}
					if (self.containsRestrictedKeyword(formFields.custentity_registration_middle_initial)) {
    		    	    self.showError('Middle name contains a restricted keyword ' + formFields.custentity_registration_middle_initial);
    		    	    return jQuery.Deferred().reject();
    		    	}
					if (self.containsRestrictedKeyword(formFields.lastname)) {
    		    	    self.showError('Last name contains a restricted keyword ' + formFields.lastname);
    		    	    return jQuery.Deferred().reject();
    		    	}
					if (self.containsRestrictedKeyword(formFields.company)) {
    		    	    self.showError('Company contains a restricted keyword ' + formFields.company);
    		    	    return jQuery.Deferred().reject();
    		    	}
    			});
			}

			if (this.options.MyAccountMenu) {
				jQuery(document).on('blur', 'input[name="firstname"]', function(e){
        			self.validateFirstNameOnBlur('First name', e);
    			});

				jQuery(document).on('blur', 'input[name="lastname"]', function(e){
        			self.validateFirstNameOnBlur('Last name', e);
    			});

				jQuery(document).on('blur', 'input[name="companyname"]', function(e){
        			self.validateFirstNameOnBlur('Company', e);
    			});
			}
		}

	,	events: {
            // 'keyup #register-firstname': 'validateFirstNameOnBlur',
			// 'click [data-action="validate"]': 'validateFirstNameOnBlur'
		}

	,	validateFirstNameOnBlur: function (field, e) {
            var value = $(e.currentTarget).val().toLowerCase().trim();

			if (this.containsRestrictedKeyword(value)) {
				alert(field + ' contains a restricted word ' + value);
				$(e.currentTarget).val('');
				this.showError(field + ' contains a restricted keyword.');
			} else {
				this.hideError();
			}
		}

	,	containsRestrictedKeyword: function (value) {
			if (!value) return false;
			
			value = value.toLowerCase().trim();

    		return this.keywordList.some(function(keyword){
        		return keyword && value.includes(keyword);
    		});
		}

	,	hideError: function () {
			this.$('[data-type="alert-placeholder"]').empty();
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BluePoint.ValidateRegistration.ValidateRegistration.View.Context
	,	getContext: function getContext()
		{
			return {
			};
		}
	});
});
